import { render, staticRenderFns } from "./addNewInstagramAccount.vue?vue&type=template&id=defc8cc8&scoped=true&"
import script from "./addNewInstagramAccount.vue?vue&type=script&lang=js&"
export * from "./addNewInstagramAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "defc8cc8",
  null
  
)

export default component.exports